import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Popover, units } from '@ha/dsl';

import { OverlayProps } from '../types';
import PopoverActions from './Popover/PopoverActions';

export const useStyles = makeStyles(theme => ({
  popoverRoot: {
    padding: units.yx(0, 1),
    [theme.breakpoints.up('sm')]: {
      padding: 0,
    },
    maxWidth: '624px',
  },
}));

const DatePickerPopover: React.FC<Omit<OverlayProps, 'onFieldFocusChange'>> =
  props => {
    const { popoverRoot } = useStyles();
    const {
      containerRef,
      children,
      onOverlayClose,
      onOverlayExit,
      open,
      OverlayTitle,
      OverlayActions,
      OverlayInfo,
    } = props;

    return (
      <Popover
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorEl={containerRef.current}
        data-test-locator="DatePicker / Overlay / Popover"
        onClose={onOverlayClose}
        onExit={onOverlayExit}
        open={open}
        PaperProps={{
          classes: { root: popoverRoot },
        }}
        transitionDuration={0}
        marginThreshold={4}
      >
        {OverlayTitle}
        {children}
        {OverlayInfo}
        <PopoverActions>{OverlayActions}</PopoverActions>
      </Popover>
    );
  };

export default DatePickerPopover;
